import CardDefault from "components/Cards/CardDefault";
import MenuDetalhesButton from "./MenuButton";
import { Row } from "antd";
import { TabsMenuOptionsRoutes } from "features/tenants/data/TabsMenuOptions";
import { checkPermission } from "infra/helpers/permission";

interface MenuDetalhesProps<T = TabsMenuOptionsRoutes> {
  light?: boolean;
  options: {
    label: string;
    icon?: any;
    route: T;
    count?: number;
    loadingCount?: boolean;
    permissions?: string[];
  }[];
  selectedOption: T;
  onChangeOption: (option: T) => any;
  disabledOptions?: string[];
  filteredOptions?: string[];
  rounded?: boolean;
  shadow?: boolean;
}

function MenuDetalhes<T = TabsMenuOptionsRoutes>({
  light,
  options,
  selectedOption,
  onChangeOption,
  disabledOptions = [],
  rounded = true,
  shadow = true,
  filteredOptions,
}: MenuDetalhesProps<T>) {
  const _options = filteredOptions?.length
    ? options.filter((option) => !filteredOptions.includes(option.route as any))
    : options;
  return (
    <CardDefault
      as={Row}
      w="100%"
      p={0}
      py={light ? 4 : 0}
      overflow="hidden"
      boxShadow={shadow ? "0 0 24px rgba(0,0,0,.05)" : "none"}
      rounded={rounded ? "16px" : 0}
    >
      {_options.map((option, key) => {
        const isSelected = selectedOption === option.route ? true : false;
        const isDisabled = disabledOptions.includes(option.route as any);

        if (
          option.permissions?.length &&
          !checkPermission(option.permissions)
        ) {
          return null;
        }

        return (
          <MenuDetalhesButton
            key={key}
            light={light}
            option={option as any}
            isSelected={isSelected}
            isDisabled={isDisabled}
            onChangeOption={() => onChangeOption(option.route)}
          />
        );
      })}
    </CardDefault>
  );
}

export default MenuDetalhes;
